export function generateIntentLink(
  device: 'ios' | 'android' | 'other',
  app: 'instagram' | 'telegram' | 'whatsapp',
  username: string
): string {
  if (!device || !app || !username) {
    throw new Error('Device, app, and username are required parameters.');
  }

  let link = '';

  switch (app) {
    case 'instagram':
      if (device === 'ios') {
        link = `instagram://user?username=${username}`;
      } else if (device === 'android') {
        link = `intent://www.instagram.com/${username}#Intent;package=com.instagram.android;scheme=https;end`;
      }
      break;

    case 'telegram':
      if (device === 'ios') {
        link = `tg://resolve?domain=${username}`;
      } else if (device === 'android') {
        link = `intent://t.me/${username}#Intent;package=org.telegram.messenger;scheme=https;end`;
      }
      break;

    case 'whatsapp':
      if (device === 'ios') {
        link = `whatsapp://send?phone=${username}`;
      } else if (device === 'android') {
        link = `intent://send?phone=${username}#Intent;package=com.whatsapp;scheme=whatsapp;end`;
      }
      break;

    default:
      throw new Error(
        'Unsupported app. Supported apps are: instagram, telegram, whatsapp.'
      );
  }

  return link;
}
